import { useRef } from "react";
import Skeleton from "react-loading-skeleton";
import { useParams } from "react-router-dom";
import { BackButton } from "../../../components/buttons/backButton";
import { Button } from "../../../components/buttons/button";
import { TicketBody } from "../../../components/ticket";
import { useGetEventGuestQuery } from "../../../redux/features/event/event.api";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../../utils/constants";
import { handleDownloadPdf } from "../../../utils/helpers";

export const ViewTicket = () => {
  const { guestId } = useParams<{ guestId: string }>();

  const ticketRef = useRef<HTMLDivElement>(null);

  const { data: guest, isFetching: fetchingGuestDetails } =
    useGetEventGuestQuery(
      {
        id: guestId ?? "",
      },
      { refetchOnMountOrArgChange: true, skip: guestId === "" },
    );

  return (
    <div className="flex w-full justify-center">
      <div className="flex w-full max-w-[460px] flex-col gap-3">
        <BackButton />

        {fetchingGuestDetails ? (
          <Skeleton
            count={1}
            width={"100%"}
            height={"500px"}
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
          />
        ) : (
          <>
            <TicketBody
              ref={ticketRef}
              downloadView={false}
              eventName={guest?.data?.eventId?.name || ""}
              startDate={guest?.data?.eventId?.startDate || ""}
              endDate={guest?.data?.eventId?.endDate || ""}
              startTime={guest?.data?.eventId?.startTime || ""}
              location={guest?.data?.eventId?.location || ""}
              qrCode={guest?.data?.qrCode || ""}
              firstName={guest?.data?.firstName || ""}
              lastName={guest?.data?.lastName || ""}
              email={guest?.data?.email || ""}
              ticketsPurchase={
                guest?.data?.tickets?.map((t) => {
                  return {
                    quantity: t.quantity,
                    ticket: t.ticketId,
                  };
                }) || []
              }
              payment={guest?.data?.payment}
            />

            <Button
              type="button"
              className="!rounded-2xl"
              onClick={async () => {
                await handleDownloadPdf(
                  ticketRef,
                  `${guest?.data?.eventId?.name}_ticket`,
                );
              }}
              text="Download"
              icon="download"
              variation="white"
            />
          </>
        )}
      </div>
    </div>
  );
};
